import React, { useEffect, useState } from 'react'
import { Checkbox, Radio, Select, Space, Table, Typography } from 'antd'
import PageHeader from 'components/pageHeader'
import { useHistory } from 'react-router'
import { InputSearch } from 'components/customInputs'
import { getUsers, setSpecificUserId, setUserDetails, updateUserToTranferData, fetchStandards, fetchCourses, } from 'actions/userManagementV2'
import { IMG_URL } from "../../env.json";
import { connect } from 'react-redux'
import PageDataLoader from 'components/pageDataLoader'
import { DeleteOutlined, SearchOutlined, PlusCircleOutlined, FilterFilled } from '@ant-design/icons'
import { Button } from 'components/Button'
import AddUser from './modals/addUser';
import UserDeleteModal from './modals/userDelete'
import PermanentDeleteModal from './modals/parmanentDeleteModal'
import { setOthersSelectedTab } from 'actions/profileNew'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import moment from 'moment'


const UserTable = ({ userType, getUsers, usersList, userObj, setSpecificUserId, updateUserToTranferData, setUserDetails, fetchStandards, standards, fetchCourses, courses, setOthersSelectedTab, user, selectedStandard, selectedCourse, resourceData, storeWithoutData, userIds, studentsDataWRTCourseType }) => {

        const history = useHistory();
        const location = useLocation()
        console.log("location", storeWithoutData);
        let fromUserManagement = true

        const [sort, setSort] = useState('');
        const [search, setSearch] = useState('');
        const [tempSearch, setTempSearch] = useState('');
        const [courseIds, setCourseIds] = useState([]);
        const [standardIds, setStandardIds] = useState([]);
        const [selectedRows, setSelectedRows] = useState([]);
        const [pageLoader, togglePageLoader] = useState(false);
        const [selectedRowKeys, setSelectedRowKeys] = useState([]);
        const [filter, setFilter] = useState({ page: 1, limit: 25 });
        const [userDeleteModalBool, setUserDeleteModalOpen] = useState(false);
        const [parmanentDeleteModal, setPermanentDeletModal] = useState(false)
        const [addUserModal, setAdduserModal] = useState(false);
        const getDefaultRoleArray = (roleTab) => {
                if (roleTab === 'Teachers') return ['Teacher'];
                if (roleTab === 'Data Operators') return ['Data Operator'];
                if (roleTab === 'Operations') return ['Operation'];
                return [];
        };

        const [defaultUser, setDefaultUser] = useState(userObj?.userRole === 'Students' ? 'Student' : 'Staff')
        const [selectedRoles, setSelectedRoles] = useState(getDefaultRoleArray(userObj?.userRole));
        const [tempSelectedRoles, setTempSelectedRoles] = useState(getDefaultRoleArray(userObj?.userRole));
        const [filterApplied, setFilterApplied] = useState(getDefaultRoleArray(userObj?.userRole).length > 0);
        const [storedUserType, setStoredUserType] = useState(getDefaultRoleArray(userObj?.userRole));

        useEffect(() => {
                const initialRoles = getDefaultRoleArray(userObj?.userRole);
                setSelectedRoles(initialRoles);
                setTempSelectedRoles(initialRoles);
                setStoredUserType(initialRoles);
                setFilterApplied(initialRoles.length > 0);
        }, [userObj?.userRole]);
        const [selectedSortRoles, setSelectedSortRoles] = useState('');
        const [tempSelectedSortRoles, setTempSelectedSortRoles] = useState('');
        const [filterSortApplied, setFilterSortApplied] = useState(false);
        const [storedSortType, setStoredSortType] = useState('');
        console.log("resourceData", sort);
        let params = {
                userType: defaultUser,
                status: ['Approved'],
                limit: 25,
                search,
                page: filter?.page,
                courseIds: location?.state?.key == "fromStandardClick" ? [resourceData?.id] : defaultUser === 'Staff' ? undefined : resourceData == -1 || userIds ? undefined : [resourceData?.id],
                standardIds: location?.state?.key == "fromStandardClick" ? [selectedStandard?.standard_id] : defaultUser === 'Staff' || selectedCourse !== 'Live Courses' ? undefined : [selectedStandard?.standard_id],
                sort: storedSortType,
                withoutCourse: selectedCourse === 'Students without courses' ? true : undefined,
                resourceType: selectedCourse == 'Video Courses' ? 'videoResource' :
                        selectedCourse == 'Online Test Series' ? 'testSeries' :
                                selectedCourse == 'Study Materials' ? 'studyMaterial' : undefined,
                userIds: location?.state?.key == "fromStandardClick" ? undefined : userIds ? userIds : undefined,
                roles: storedUserType
        };

        console.log({ resourceData })
        console.log({ selectedCourse })


        useEffect(() => {
                if (tempSearch === '') {
                        setSearch('');
                        setFilter(prev => ({ ...prev, page: 1 }));
                        return;
                }

                const delayDebounceFn = setTimeout(() => {
                        setSearch(tempSearch);
                        setFilter(prev => ({ ...prev, page: 1 }));
                }, 400); // 400ms debounce delay

                return () => clearTimeout(delayDebounceFn);
        }, [tempSearch]);


        useEffect(() => {
                togglePageLoader(true);
                getUsers(params, () => togglePageLoader(false));
        }, [search, filter, standardIds, courseIds, defaultUser, sort, storedUserType, storedSortType, selectedCourse, storeWithoutData, selectedStandard, userIds]);

        const setIdToDelete = (id) => {
                selectedRowKeys.push(id);
                setSelectedRowKeys([...selectedRowKeys]);
        };

        const openDeleteModal = (e, record) => {
                setUserDeleteModalOpen(true);
                e.stopPropagation();
                setIdToDelete(record?.id);
        }
        const openPermanentDeleteModal = (e, record) => {
                setPermanentDeletModal(true);
                e.stopPropagation();
                setIdToDelete(record?.id);
        }


        const handleRoleChange = (checkedValues) => {
                setTempSelectedRoles(checkedValues);
        };

        // const applyFilters = (closeDropdown) => {
        //         setSelectedRoles(tempSelectedRoles);
        //         setStoredUserType(tempSelectedRoles)
        //         setFilterApplied(true);
        //         closeDropdown();
        // };
        const applyFilters = (confirmAndClose) => {
                setSelectedRoles(tempSelectedRoles);
                setStoredUserType(tempSelectedRoles);
                setFilterApplied(true);

                confirmAndClose?.();
        };

        const applySortFilters = (confirmAndClose) => {
                setSelectedSortRoles(tempSelectedSortRoles);
                setStoredSortType(tempSelectedSortRoles);
                setFilterSortApplied(!!tempSelectedSortRoles);

                confirmAndClose?.();
        };

        const resetFilters = (closeDropdown) => {
                setTempSelectedRoles(selectedRoles);
                closeDropdown();
        };
        const handleSortChange = (selectedValue) => {
                setTempSelectedSortRoles(selectedValue);
        };

        // const applySortFilters = (closeDropdown) => {
        //         setSelectedSortRoles(tempSelectedSortRoles);
        //         setStoredSortType(tempSelectedSortRoles);
        //         setFilterSortApplied(!!tempSelectedSortRoles);
        //         closeDropdown();
        // };

        const resetSortFilters = (closeDropdown) => {
                setSelectedSortRoles('');
                setTempSelectedSortRoles('');
                setFilterSortApplied(false);
                closeDropdown();
                setStoredSortType('');
        };


        const isChanged = JSON.stringify([...tempSelectedRoles].sort()) !== JSON.stringify([...selectedRoles].sort());

        const filterMenu = (closeDropdown) => (
                <div style={{ padding: '10px' }}>
                        <div>
                                <Checkbox.Group
                                        options={[
                                                { label: 'Teacher', value: 'Teacher' },
                                                { label: 'Data Operator', value: 'Data Operator' },
                                                { label: 'Operations', value: 'Operation' },
                                        ]}
                                        value={tempSelectedRoles}
                                        onChange={handleRoleChange}
                                        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                                />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                                <div
                                        onClick={() => { if (isChanged) setTempSelectedRoles([...selectedRoles]); }}
                                        style={{
                                                cursor: isChanged ? 'pointer' : 'not-allowed',
                                                color: '#594099',
                                                opacity: isChanged ? 1 : 0.5
                                        }}
                                >
                                        RESET
                                </div>
                                <div onClick={() => { if (tempSelectedRoles?.length !== 0) { applyFilters(closeDropdown); } }} style={{ cursor: tempSelectedRoles?.length !== 0 ? 'pointer' : 'not-allowed', color: '#fff', width: 30, height: 24, display: "flex", justifyContent: "center", backgroundColor: '#594099', fontSize: "14px", opacity: tempSelectedRoles?.length !== 0 ? 1 : 0.5 }}>OK</div>
                        </div>
                </div>
        );

        const renderSortMenu = (closeDropdown) => (
                <div style={{ padding: '10px' }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                                <Checkbox
                                        checked={tempSelectedSortRoles === 'alphabetical'}
                                        onChange={() => handleSortChange('alphabetical')}
                                >
                                        Alphabetical order
                                </Checkbox>
                                <Checkbox
                                        style={{ marginLeft: 0 }}
                                        checked={tempSelectedSortRoles === 'newest'}
                                        onChange={() => handleSortChange('newest')}
                                >
                                        Newest first
                                </Checkbox>
                                <Checkbox
                                        style={{ marginLeft: 0 }}
                                        checked={tempSelectedSortRoles === 'oldest'}
                                        onChange={() => handleSortChange('oldest')}
                                >
                                        Oldest first
                                </Checkbox>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                                <div
                                        onClick={() => {
                                                if (tempSelectedSortRoles) resetSortFilters(closeDropdown);
                                        }}
                                        style={{
                                                cursor: tempSelectedSortRoles ? 'pointer' : 'not-allowed',
                                                color: '#594099',
                                                opacity: tempSelectedSortRoles ? 1 : 0.5,
                                        }}
                                >
                                        RESET
                                </div>
                                <div
                                        onClick={() => {
                                                if (tempSelectedSortRoles) applySortFilters(closeDropdown);
                                        }}
                                        style={{
                                                cursor: tempSelectedSortRoles ? 'pointer' : 'not-allowed',
                                                color: '#fff',
                                                width: 30,
                                                height: 24,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: '#594099',
                                                fontSize: '14px',
                                                opacity: tempSelectedSortRoles ? 1 : 0.5,
                                        }}
                                >
                                        OK
                                </div>
                        </div>
                </div>
        );





        console.log("sort-126", sort);
        const columns = (userType, usersList, user) => {
                const renderName = (value, record) => (
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: 0 }}>
                                {console.log("record", record)}
                                <img src={`${IMG_URL}/${record?.image ? record?.image : 'default.png'}`} alt="" style={{ width: '20px', marginRight: '10px' }} />
                                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', fontWeight: 600 }}>
                                        <Typography.Text ellipsis={{ tooltip: true }}>{value}</Typography.Text>
                                </div>
                        </div>
                );
                const baseColumns = [
                        {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                width: '20%',
                                render: renderName,
                                // filters:null,
                                // filterDropdown: ({ confirm }) => renderSortMenu(confirm),
                                filterDropdown: ({ confirm, close }) =>
                                        renderSortMenu(() => {
                                                confirm();
                                                close();
                                        }),
                                filterIcon: (filtered) => <FilterFilled style={{ color: selectedSortRoles ? 'black' : undefined }} />,
                                filteredValue: selectedSortRoles ? [selectedSortRoles] : [],
                                onFilter: (value, record) => {
                                        if (!selectedSortRoles) return true;
                                        return true;
                                },
                                sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
                        },
                ];





                if (userType !== 'Students') {
                        baseColumns.push({
                                title: 'Role',
                                dataIndex: 'role',
                                key: 'role',
                                render: (value, record) => (
                                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                {record?.role ? (record?.role === 'Operation' ? 'Operations' : record?.role) : 'NA'}
                                        </div>
                                ),
                                // filters: null,
                                // filterDropdown: ({ confirm }) => filterMenu(confirm),
                                filterDropdown: ({ confirm, close }) =>
                                        filterMenu(() => {
                                                confirm();
                                                close();
                                        }),
                                filterIcon: (filtered) => <FilterFilled style={{ color: selectedRoles?.length ? 'black' : undefined }} />,
                                onFilterDropdownOpenChange: (visible) => {
                                        if (visible) {
                                                setTempSelectedRoles(selectedRoles);
                                        }
                                },
                                // filteredValue: filterApplied ? selectedRoles : null,
                                filteredValue: selectedRoles?.length ? selectedRoles : [],
                                onFilter: (value, record) => selectedRoles.length === 0 || selectedRoles.includes(record?.role),
                        });

                        baseColumns.push({
                                title: 'Privilege(s)',
                                dataIndex: 'privilages',
                                key: 'privilages',
                                render: (value, record) => <div style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>{record?.privilage ? (typeof record.privilage === 'string' ? record.privilage.split(',').map(item => item.trim()).join(', ') : record.privilage) : 'NA'}</div>


                        });
                } else {
                        baseColumns.push(
                                {
                                        title: 'Mobile No',
                                        dataIndex: 'mobileNo',
                                        key: 'mobileNo',
                                        render: (value, record) => <div style={{ display: 'flex', justifyContent: 'flex-start' }}>{record?.phone ? record?.phone : 'NA'}</div>,
                                },
                                {
                                        title: 'Courses',
                                        dataIndex: 'courses',
                                        key: 'courses',
                                        render: (value, record) => (
                                                <div style={{
                                                        textAlign: 'left',
                                                        width: 120,
                                                }}>
                                                        <Typography.Text style={{ width: '100%' }} ellipsis={{ tooltip: true }}>
                                                                {record?.courses ? record?.courses : 'NA'}
                                                        </Typography.Text>
                                                </div>
                                        ),
                                },
                                {
                                        title: 'Registration on',
                                        dataIndex: 'registered on',
                                        key: 'registered on',
                                        render: (value, record) => <div style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>{moment(record?.createdAt, 'YYYY-MM-DD').format('DD/MM/YYYY')}</div>
                                }
                        );
                }

                baseColumns.push({
                        title: 'Action',
                        dataIndex: 'status',
                        key: 'status',
                        render: (value, record) => {
                                return <div className='' style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                        {(user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin')) && (
                                                <>
                                                        <Button onClick={(e) => openDeleteModal(e, record)} type='transparent' style={{ color: '#636363', padding: 0 }} disabled={selectedRowKeys.includes(record.id)}>SUSPEND</Button>
                                                        <Button onClick={(e) => openPermanentDeleteModal(e, record)} type='transparent' style={{ color: '#FF414D', marginLeft: 10 }} disabled={selectedRowKeys.includes(record.id)}>DELETE</Button>

                                                        {record?.role == "Teacher" && (
                                                                <Button type='transparent' onClick={(e) => { e.stopPropagation(); updateUserToTranferData(record); history.push('/user-management/transfer-data') }} style={{ color: '#FFA931' }} disabled={selectedRowKeys.includes(record.id)}>MANAGE</Button>
                                                        )}
                                                </>
                                        )
                                        }
                                </div >
                        }
                });

                return baseColumns;
        };


        const rowSelection = {
                type: "checkbox",
                selectedRowKeys: selectedRowKeys,
                onChange: (selectedRowKeys, selections) => {
                        setSelectedRows([...selections?.map(item => item?.fileKey)]);
                        setSelectedRowKeys([...selectedRowKeys]);
                },
        };

        const callbackForAddUsers = () => {
                togglePageLoader(true)
                getUsers(params, () => togglePageLoader(false))
        }

        const actions = [
                <>
                        {(user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin')) ?
                                <>
                                        <Button type='archive' style={{ marginRight: 10, }} disabled={selectedRowKeys?.length < 1} onClick={() => { setUserDeleteModalOpen(true); }}>SUSPEND</Button>
                                        <Button type='delete' style={{ marginRight: 10, }} disabled={selectedRowKeys?.length < 1} onClick={() => { setPermanentDeletModal(true) }}>DELETE</Button>
                                        {(userObj?.userRole === 'Teachers' || userObj?.userRole === 'Data Operators' || userObj?.userRole === 'Operations') && (
                                                <Button style={{ marginRight: 10 }} onClick={() => setAdduserModal(true)} type='primary' icon={<PlusCircleOutlined />}>ADD USER</Button>
                                        )}
                                </>
                                : null}
                        <InputSearch
                                allowClear
                                placeholder='Search by name/mobile'
                                value={tempSearch}
                                onInputChange={(val) => setTempSearch(val)}
                                onClear={() => setTempSearch('')}
                                onEnter={(val) => { setSearch(val); setFilter({ ...filter, page: 1 }); }}
                                style={{ borderRadius: "32px" }}
                        />
                </>
        ];

        const onDeleteModalCancel = () => {
                setUserDeleteModalOpen(false)
        };

        const onPermanentDeleteModalCancel = () => {
                setPermanentDeletModal(false)
        };

        const onRow = (record, rowIndex) => {
                return {
                        style: { cursor: 'pointer' },
                        onClick: () => {
                                history.push({
                                        pathname: '/user-management/profile',
                                        state: {
                                                key: fromUserManagement
                                        }
                                })
                                setSpecificUserId(record?.id);
                                setUserDetails(record);
                                setOthersSelectedTab('Basic Profile');
                        }
                }
        }



        return (
                <div>
                        <PageHeader
                                title={
                                        userObj?.userRole === 'Students'
                                                ? selectedStandard?.std == undefined
                                                        ? selectedCourse === 'Students without courses'
                                                                ? `${selectedCourse} (${studentsDataWRTCourseType?.studentWithoutCoursesCount ?? 0})`
                                                                : `${selectedCourse} (${usersList?.meta?.totalItems ?? 0})`
                                                        : `${selectedStandard.std}${selectedStandard.section ? ` - ${selectedStandard.section}` : ''} (${usersList?.meta?.totalItems ?? 0})`
                                                : (userObj?.userRole === 'Teachers' || userObj?.userRole === 'Data Operators' || userObj?.userRole === 'Operations')
                                                        ? (() => {
                                                                if (storedUserType.length === 0) return 'Staff';
                                                                if (storedUserType.length === 3) return 'All staff';
                                                                const roleLabels = {
                                                                        'Teacher': 'Teachers',
                                                                        'Data Operator': 'Data Operators',
                                                                        'Operation': 'Operations'
                                                                };
                                                                return storedUserType.map(role => roleLabels[role]).join(' & ');
                                                        })()
                                                        : selectedCourse
                                }
                                actions={actions}
                                onBackPress={() => history.goBack()}
                        />
                        {pageLoader ? <></> :
                                <div className='m-t-60'>
                                        <Table
                                                loading={pageLoader}
                                                style={{ width: "100vw" }}
                                                columns={columns(userObj?.userRole, usersList, user)}
                                                dataSource={usersList?.items || []}
                                                rowSelection={rowSelection}
                                                rowKey={record => record?.id}
                                                onRow={onRow}
                                                pagination={{
                                                        total: usersList?.meta?.totalItems,
                                                        pageSize: filter?.limit,
                                                        current: filter?.page,
                                                        size: 'small',
                                                        showTotal: (total, range) => <div>Showing {range[0]} - {range[1]} of {total}</div>,
                                                        onChange: (page) => setFilter({ ...filter, page }),
                                                        showSizeChanger: false
                                                }}
                                        />
                                </div>
                        }
                        <PageDataLoader visible={pageLoader} />
                        {userDeleteModalBool && <UserDeleteModal params={params} togglePageLoader={togglePageLoader} getUsers={getUsers} setSelectedRowKeys={setSelectedRowKeys} selectedRowKeys={selectedRowKeys} open={userDeleteModalBool} onCancel={() => onDeleteModalCancel()} />}
                        {parmanentDeleteModal && <PermanentDeleteModal params={params} togglePageLoader={togglePageLoader} getUsers={getUsers} setSelectedRowKeys={setSelectedRowKeys} selectedRowKeys={selectedRowKeys} open={parmanentDeleteModal} onCancel={() => onPermanentDeleteModalCancel()} />}
                        {addUserModal && <AddUser open={addUserModal} onCancel={() => setAdduserModal(false)} callbackForAddUsers={callbackForAddUsers} />}
                </div>
        )
}

const mapStateToProps = (state) => {
        const { user } = state.session;
        const { usersList, userObj, standards, courses, selectedStandard, selectedCourse, storeWithoutData, userIds, studentsDataWRTCourseType } = state.userManagementV2;
        const { resourceData } = state.feeManagement;
        return { usersList, userObj, standards, courses, user, selectedStandard, selectedCourse, resourceData, storeWithoutData, userIds, studentsDataWRTCourseType }
};

const mapDispatchToProps = (dispatch) => ({
        getUsers: (params, callback) => dispatch(getUsers(params, callback)),
        setSpecificUserId: id => dispatch(setSpecificUserId(id)),
        updateUserToTranferData: data => dispatch(updateUserToTranferData(data)),
        setUserDetails: res => dispatch(setUserDetails(res)),
        setOthersSelectedTab: (tab) => dispatch(setOthersSelectedTab(tab)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserTable);